/**
 * The control a person pressed (KPR-1768; docs/plans/ipad-app.md, Decision 8).
 *
 * `saveFile`, `print` and `share` take an optional `anchor`: the element that
 * was pressed. The web ignores it; the app's popover (the share sheet, the
 * print panel on iPad) points at it. A call site passes `anchorOf(event)`
 * read at the start of its handler, before any `await`.
 *
 * A menu action is called without its event (components/common/actionMenu.js),
 * so the menu records the item pressed for the length of that call and
 * `anchorOf()` with no event falls back to it.
 */
let active = null;

const isElement = value => Boolean(value) && typeof value === 'object' && value.nodeType === 1;

/** The element behind a React/DOM event, an antd `{ domEvent }`, or an element passed as is; else the menu's pressed item, else null. */
export function anchorOf(event) {
	const raw = event?.domEvent || event;
	const found = isElement(raw) ? raw : raw?.currentTarget;
	return isElement(found) ? found : active;
}

/** Runs `fn` with `element` as the pressed control (the action menu's use). */
export function withActiveAnchor(element, fn) {
	const before = active;
	active = isElement(element) ? element : null;
	try {
		return fn();
	} finally {
		active = before;
	}
}
